import { useQuery, UseQueryResult } from 'react-query';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

export interface OrganizationByShopifyStore {
    id: number,
}

export const GET_ORG_BY_SHOPIFY_STORE = 'GET_ORG_BY_SHOPIFY_STORE';

const useGetOrgByShopifyStore = (
  shopifyStore: string,
): UseQueryResult<ApiResponse<OrganizationByShopifyStore>, ApiError<OrganizationByShopifyStore>> => useQuery<
    ApiResponse<OrganizationByShopifyStore>,
    ApiError<OrganizationByShopifyStore>
>(
  [`${GET_ORG_BY_SHOPIFY_STORE}_${shopifyStore}`],
  async () => dataFetch.get(`${DIGGER_API_SUFFIX}organizations/shopify/${shopifyStore}`),
);

export default useGetOrgByShopifyStore;
